<template>
  <div class="register">
    <div class="page-header">
      <div class="header-inner">
        <div class="company-logo">
          <!--<img src="../../assets/images/page1/logo1.png" alt />-->
          <!--<span class="split"></span>-->
          <img src="../../assets/phone/page/logo2.png" alt  @click="handleClick('/indexPage')"/>
        </div>
        <div class="back-to-index">
          <div class="point back" style="" @click="goBack">返回首页</div>
        </div>
      </div>
    </div>
    <div class="main-body">
      <div class="register-form">
        <div class="form-item" v-for="(formItem,index) in formItems" :key="formItem.blur">
          <div class="form-item-name">
            {{formItem.name}}
            <span>*</span>
          </div>
          <div class="form-item-info">
            <img :src="focusIndex==index?formItem.focus:formItem.blur" alt />
            <input
              class="form-item-text"
              type="text"
              v-model="registerForm[formItem.prop]"
              :placeholder="formItem.placeholder"
              @focus="focusIndex=index;"
              @blur="focusIndex=-1"
              @input="validateInput(formItem.prop,$event)"
            />
            <span class="form-item-tip">{{formItem.tip}}</span>
          </div>
        </div>
        <div class="form-item">
          <div class="sign btn point" @click="submitRegister">提交</div>
        </div>
      </div>
      <div class="login">
        <div>我已注册，现在就</div>
        <div class="login-btn btn point" @click="yxgjLogin">登录</div>
          <div>联系电话：18068825213</div>
      </div>
    </div>
    <div class="mask" :class="showSuccess ? 'shown': ''">
      <div class="success">
        <img src="../../assets/images/register/success_bg.png" alt />
        <div class="success-title">提交成功</div>
        <p class="success-content">感谢您的配合，我们将于</p>
        <p>1-2个工作日内与您联系</p>
        <div class="btn point done" @click="known">知道了</div>
      </div>
    </div>
    <div class="alert" :class="{shown:errorMsg.show}">
      {{errorMsg.msg}}
      <span class="alert-close point" @click="errorMsg.show=false">x</span>
    </div>
      <footer-common :isShowTopBtn="isShowTopBtn"> </footer-common>
  </div>
</template>

<script>
import footerCommon from '../common/footerCommon';
export default {
    name: "register",
    data() {
        return {
            registerForm: {
                unitName: "",
                userName: "",
                phoneNumber: ""
            },
            formItems: [
                {
                    prop: "unitName",
                    type: "text",
                    name: "单位名称",
                    required: true,
                    blur: require("../../assets/images/register/unit.png"),
                    focus: require("../../assets/images/register/unit_focus.png"),
                    tip: "提前了解您的业务特征，安排合适的顾问",
                    placeholder: "请输入单位名称"
                },
                {
                    prop: "userName",
                    type: "text",
                    name: "姓名",
                    required: true,
                    blur: require("../../assets/images/register/user.png"),
                    focus: require("../../assets/images/register/user_focus.png"),
                    tip: "希望我们如何称呼您？",
                    placeholder: "请输入姓名"
                },
                {
                    prop: "phoneNumber",
                    type: "number",
                    name: "手机号码",
                    required: true,
                    blur: require("../../assets/images/register/phone.png"),
                    focus: require("../../assets/images/register/phone_focus.png"),
                    tip: "顾问将于1-2个工作日内致电您。",
                    placeholder: "请输入手机号码"
                }
            ],
            focusIndex: -1,
            showSuccess: false,
            errorMsg: {
                show: false,
                msg: ""
            },
            isShowTopBtn: false
        };
    },
    components: {
        footerCommon
    },
    methods: {
        goBack() {
            this.$router.push({ path: "/" });
        },
        validatePass(index) {
            console.log(index);
            this.focusIndex = -1;
        },
        validateInput(prop, e) {
            // console.log(e.data)
            if (prop === "phoneNumber") {
                if (e.data) {
                    this.registerForm.phoneNumber = this.registerForm.phoneNumber.replace(
                        /[^\d]/g,
                        ""
                    );
                }
                // console.log(this.registerForm.phoneNumber);
                this.registerForm.phoneNumber = this.registerForm.phoneNumber.replace(
                    /[^\d]/g,
                    ""
                );
                // console.log(e);
                // let phoneTest = /[0-9]/;
                // if (!phoneTest.test(e.data)) {
                //   this.errorShow("手机号码仅能输入0-9的数字");
                //   this.registerForm.phoneNumber = this.registerForm.phoneNumber.substr(
                //     0,
                //     this.registerForm.phoneNumber.length - 1
                //   );
                //   return;
                // }
            }
        },
        submitRegister() {
            if (this.registerForm.unitName.trim() === "") {
                // console.log("单位错了");
                this.errorShow("请输入单位名称");
                return;
            }
            if (this.registerForm.unitName.trim().length > 40) {
                console.log("单位错了");
                this.errorShow("单位名称最多输入40个字符，请重新输入");
                return;
            }
            if (this.registerForm.userName.trim() === "") {
                // console.log("错了");
                this.errorShow("请输入姓名");
                return;
            }

            if (this.registerForm.userName.trim().length > 30) {
                // console.log("错了");
                this.errorShow("姓名最多输入30个字符，请重新输入");
                return;
            }
            let phoneTest = /^1[3456789]\d{9}$/;
            if (this.registerForm.phoneNumber.length === 0) {
                // console.log("电话错了");
                this.errorShow("请输入手机号码");
                return;
            }

            if (this.registerForm.phoneNumber.length !== 11 || !phoneTest.test(this.registerForm.phoneNumber)) {
                // console.log("电话错了");
                this.errorShow("手机号码填写有误，请重新输入");
                return;
            }

            let that = this;
            this.registerForm.type = "ACCOUNT_APPLY";
            this.$axios
                .post("/customer/doApply", this.registerForm)
                .then(function(res) {
                    if (Number(res.data.code) === 0) {
                        that.showSuccess = true;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        errorShow(msg) {
            this.errorMsg.show = true;
            this.errorMsg.msg = msg;
            setTimeout(() => {
                this.errorMsg.show = false;
            }, 2500);
        },
        yxgjLogin() {
            // window.location.href = "http://119.27.160.213:8087/web/login";
            window.location.href = this.$store.state.loginUrl;
        },
        known() {
            this.showSuccess = false;
            this.registerForm.unitName = "";
            this.registerForm.userName = "";
            this.registerForm.phoneNumber = "";
        },
        handleClick(path) {
            this.$router.push({
                path: path,
                query: {}
            });
        }
    },
    mounted() {
    // this.$axios.get("/customer/postApplyVisit", {}).then(res=> {
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });
    }
};
</script>

<style scoped>
.page-header {
  width: 100%;
  position: fixed;
  z-index: 100;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.header-inner {
  width: 1024px;
  height: 62px;
  line-height: 62px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.company-logo > span.split {
  display: inline-block;
  position: relative;
  height: 20px;
  width: 1px;
  background-color: #dddefc;
  margin: 0 10px;
  top: 5px;
}

.company-logo > img {
  vertical-align: middle;
}

.back {
  height: 32px;
  width: 80px;
  line-height: 32px;
  border: 1px solid #b4b4b4;
  font-size: 16px;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 15px;
}
.back:hover {
  background-color: rgb(240, 233, 233);
}

.main-body {
  width: 956px;
  text-align: left;
  margin: 0 auto;
  padding-top: 182px;
}

.register-form .form-item {
  position: relative;
  font-size: 0;
}

.form-item .form-item-name,
.form-item .form-item-info {
  display: inline-block;
}

.form-item .form-item-name {
  width: 140px;
  text-align: right;
  margin-right: 20px;
  font-size: 18px;
}

.form-item .form-item-name span {
  color: #ff0000;
}

.form-item .form-item-info {
  width: 420px;
  position: relative;
  padding-bottom: 44px;
}

.form-item .form-item-info img {
  position: absolute;
  left: 19px;
  top: 14px;
}

.form-item .form-item-info .form-item-tip {
  font-size: 14px;
  line-height: 1;
  color: #aaa;
  position: absolute;
  bottom: 20px;
  left: 0;
}

.form-item .form-item-info input {
  width: 100%;
  height: 52px;
  border-radius: 10px;
  background-color: #f1f1f1;
  border: none;
  outline: none;
  padding-left: 53px;
  font-size: 18px;
  color: #333;
  box-sizing: border-box;
  border: 1px solid transparent;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.form-item .form-item-info input:focus {
  border-color: #00a0e9;
  box-shadow: 0 0 3px #00a0e9;
}

input::placeholder {
  color: #a9b3b9;
}

:-ms-input-placeholder.form-item-text {
  color: #a9b3b9!important;
}

.sign {
  width: 420px;
  height: 52px;
  line-height: 56px;
  border-radius: 10px;
  margin-left: 164px;
  margin-top: 8px;
  /* background-color: #00a0e9; */
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.login {
  display: flex;
  width: 100%;
  height: 126px;
  align-items: center;
  background-color: #f5fbff;
  border: 1px solid #d2eeff;
  margin-top: 40px;
  padding-left: 180px;
  font-size: 18px;
  color: #333;
  box-sizing: border-box;
}

.login .login-btn {
  height: 46px;
  line-height: 46px;
  width: 80px;
  margin-left: 10px;
    margin-right: 15px;
  /* background-color: #00a0e9; */
  border-radius: 5px;
  color: #fff;
  text-align: center;
}

.point {
  cursor: pointer;
}

.btn {
  background-color: #00a0e9;
}
.btn:hover {
  background-color: #4a97bb;
}

.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  padding-top: 182px;
  display: none;
}

.mask.shown {
  display: block;
}

.mask .success {
  height: 340px;
  width: 384px;
  background-color: #fff;
  border-radius: 10px;
  margin: 0 auto;
  position: relative;
  margin-top: 80px;
}
.mask .success img {
  margin: 0 auto;
  margin-top: -80px;
}

.mask .success .success-title {
  margin-top: 18px;
  line-height: 1;
  margin-bottom: 3px;
  font-size: 24px;
  color: #333;
}

.mask .success p {
  font-size: 14px;
  color: #aaa;
  line-height: 28px;
}

.mask .success .done {
  height: 51px;
  width: 327px;
  line-height: 51px;
  color: #fff;
  border-radius: 25px;
  margin: 23px auto;
}

.alert {
  height: 60px;
  background-color: rgba(247, 60, 60, 0.6);
  width: 600px;
  position: absolute;
  top: -80px;
  border: 1px solid #ddd;
  border-radius: 10px;
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.3s linear;
  font-size: 18px;
  /* font-weight:bold; */
  line-height: 60px;
  color: #fff;
  z-index: 120;
}

.alert.shown {
  top: 80px;
}

.alert .alert-close {
  position: absolute;
  display: inline-block;
  height: 100%;
  padding: 0 20px;
  right: 0;
}
.alert .alert-close:hover {
  background-color: rgba(247, 60, 60, 0.3);
}

@media screen and (max-width: 1366px) {
  .main-body {
    padding-top: 100px;
  }

  .mask {
    padding-top: 100px;
  }
}
.main-body {
    padding-bottom: 30px;
}

@media screen and (min-width: 1367px) {
    .footer-style{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .main-body {
        padding-top: 150px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue